import { useEffect, useMemo, useState } from 'react'
import { useFilterChipData } from '../../hooks/useFilterChipData'
import { ChipItem, EntityType } from '../types'
import { MAX_VISIBLE_CHIPS, RECORD_TYPE_LABELS } from '../constants'

export function useData() {
  const [open, setOpen] = useState(true)

  const {
    selectedTypes,
    myRecords,
    showFilterChips,
    selectedKnockStatusIds,
    selectedKnockStatuses,
    d2dKnockEnabled,
  } = useFilterChipData()

  const allChips: ChipItem[] = useMemo(() => {
    const chips: ChipItem[] = []

    if (myRecords) {
      chips.push({ type: 'myRecords', label: 'My Records', key: 'my-records' })
    }

    selectedTypes.forEach((type) => {
      chips.push({
        type: 'recordType',
        label: RECORD_TYPE_LABELS[type as EntityType] ?? type,
        key: type,
        id: type,
      })
    })

    if (d2dKnockEnabled) {
      selectedKnockStatuses.forEach((status) => {
        if (status) {
          chips.push({
            type: 'knockStatus',
            label: status.name,
            key: `knock-${status.id}`,
            id: String(status.id),
          })
        }
      })
    }

    return chips
  }, [myRecords, selectedTypes, selectedKnockStatuses, d2dKnockEnabled])

  const visibleChips = allChips.slice(0, MAX_VISIBLE_CHIPS)
  const extraCount = Math.max(0, allChips.length - MAX_VISIBLE_CHIPS)

  // Warn only when nothing is selected to display on the map. The
  // "No results found for the applied filters." banner was removed (SH-858),
  // so this is the only remaining alert.
  const showNoTypesWarning =
    selectedTypes.length === 0 &&
    (!d2dKnockEnabled || selectedKnockStatusIds.length === 0)

  useEffect(() => {
    if (showNoTypesWarning) {
      setOpen(true)
    }
  }, [showNoTypesWarning])

  return {
    open,
    setOpen,
    showFilterChips,
    showNoTypesWarning,
    visibleChips,
    extraCount,
    selectedTypes,
    selectedKnockStatusIds,
  }
}
